module.exports = __webpack_public_path__ + "img/c08_unitjuggernaut_Normal_ua.b178bc62.webp";